import * as React from 'react';
import Container from '@mui/material/Container';
import { black, fontBrand, gold, TypographyBrand, white } from '../../../../getLPTheme';
import { Typography, Box, Card, CardMedia, Paper } from "@mui/material";
import Avatar from '@mui/material/Avatar';
import { options } from '@config';
import Loading from '../../../../auxiliares/loading';


export default function MyCredential() {
    const avatarStyle = { height: 170, width: 170 };
    const avatarStyleQR = { height: 250, width: 250 };
    const avatarStyleSmall = { height: 150, width: 150 };
    const avatarStyleQRSmall = { height: 200, width: 200 };
    const paperStyleMedium = { height: '100%', width: "100%", alignItems: "center", justifyContent: "center" };

    const [userData, setUserData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    const userId = localStorage.getItem("CLUB-VIP-USER");

    React.useEffect(() => {
        // Fetch user data from the backend
        const fetchUserData = async () => {
            try {
                const response = await fetch(`${options.api.url}userid?uid=${userId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Error fetching user data');
                }
                const result = await response.json();
                setUserData(result);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [userId]);

    if (loading) {
        return <Loading/>;
    }

    if (error) {
        return <TypographyBrand>Error: {error}</TypographyBrand>;
    }

    if (!userData) {
        return <TypographyBrand>No se encontraron datos del usuario.</TypographyBrand>;
    }

    return (
        <Container sx={{ p: 2 }}>
            <Card sx={{ width: '100%' }}>
                <Box sx={{ backgroundColor: black[1000], pt: 1 }}>
                    <Typography variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: { xs: '5vw', sm: '2vw' }, backgroundColor: black[1000] }}>
                        Mi Credencial WGC
                    </Typography>
                </Box>

                <Box sx={{ display: { xs: 'none', sm: 'flex', md: 'flex', xl: 'flex' }, direction: "row", justifyContent: "center", alignItems: "center", backgroundColor: black[1000] }}>
                    <Box sx={{ px: 3 }}>
                        <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                            <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                <Box sx={{ borderRadius: 2, position: 'relative', border: 1, borderColor: gold[500], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 346, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                    <Paper elevation={24} style={paperStyleMedium}>
                                        <CardMedia component='img' image={"images/plantilla-credential/card-text.png"} sx={{ width: 331, height: 563 }} />
                                        <Box sx={{ width: "100%", position: 'absolute', top: "28%", left: 0, backgroundColor: 'transparent' }}>
                                            <Box sx={{ width: 346, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                <CardMedia component='img' image={userData.avatar} sx={{ bgcolor: "black", p: 0 }} style={avatarStyle} />
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "65%", left: 0 }}>
                                            <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                    {userData.name} {userData.lastname}
                                                </Typography>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                    {userData.dni}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "82%", left: 0 }}>
                                            <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                    MIEMBRO {userData.numbermembership}
                                                </Typography>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                    {userData.country}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                            <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                <Box sx={{ borderRadius: 2, position: 'relative', border: 1, borderColor: gold[500], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 346, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                    <Paper elevation={24} style={paperStyleMedium}>
                                        <CardMedia component='img' image={"images/plantilla-credential/card-text-sin-logo.png"} sx={{ width: 331, height: 563 }} />
                                        <Box sx={{ width: "100%", position: 'absolute', top: "15%", left: 0, backgroundColor: 'transparent' }}>
                                            <Box sx={{ width: 346, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                <CardMedia component='img' image={userData.qrCodeUrl} sx={{ bgcolor: "black", p: 0 }} style={avatarStyleQR} />
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "65.6%", left: 0 }}>
                                            <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                    CUALQUIER DUDA REFERIRSE AL CORREO:
                                                </Typography>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                    WORLDGOLFCLUB.ADM@GMAIL.COM
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "88%", left: 0 }}>
                                            <Box sx={{ width: 330, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '100%' }}>
                                                    WWW.WORLDGOLFCLUB.COM.AR
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* Pantalla celular */}

                <Box sx={{ display: { xs: 'grid', sm: 'none', md: 'none', xl: 'none' }, direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: black[1000] }}>
                    <Box sx={{ px: 3 }}>
                        <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                            <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                <Box sx={{ borderRadius: 2, position: 'relative', border: 1, borderColor: gold[500], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 310, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                    <Paper elevation={24} sx={{width: 310}}>
                                        <CardMedia component='img' image={"images/plantilla-credential/card-text.png"} sx={{ width: 300, height: 500 }} />
                                        <Box sx={{ width: "100%", position: 'absolute', top: "28%", left: 0, backgroundColor: 'transparent' }}>
                                            <Box sx={{ width: 310, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                <CardMedia component='img' image={userData.avatar} sx={{ bgcolor: "black", p: 0 }} style={avatarStyle} />
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "65%", left: 0 }}>
                                            <Box sx={{ width: 310, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                    {userData.name} {userData.lastname}
                                                </Typography>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '100%' }}>
                                                    {userData.dni}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "82%", left: 0 }}>
                                            <Box sx={{ width: 310, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                    MIEMBRO {userData.numbermembership}
                                                </Typography>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '140%' }}>
                                                    {userData.country}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ backgroundColor: black[1000], position: 'relative', paddingBottom: 2 }}>
                            <Box sx={{ pt: 2, display: "grid", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                <Box sx={{ borderRadius: 2, position: 'relative', border: 1, borderColor: gold[500], display: { xs: 'flex', md: 'flex' }, gridTemplateColumns: { md: '1fr 1fr' }, padding: 1, width: 310, height: "100%", direction: "column", justifyContent: "center", alignItems: "center" }}>
                                    <Paper elevation={24} sx={{width: 310}}>
                                        <CardMedia component='img' image={"images/plantilla-credential/card-text-sin-logo.png"} sx={{ width: 300, height: 500 }} />
                                        <Box sx={{ width: "100%", position: 'absolute', top: "15%", left: 0, backgroundColor: 'transparent' }}>
                                            <Box sx={{ width: 310, display: "grid", direction: "column", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent' }}>
                                                <CardMedia component='img' image={userData.qrCodeUrl} sx={{ bgcolor: "black", p: 0 }} style={avatarStyleQR} />
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "65.6%", left: 0 }}>
                                            <Box sx={{ width: 310, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                    CUALQUIER DUDA REFERIRSE AL CORREO:
                                                </Typography>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: white[50], fontSize: '75%' }}>
                                                    WORLDGOLFCLUB.ADM@GMAIL.COM
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ p: 2, position: 'absolute', top: "88%", left: 0 }}>
                                            <Box sx={{ width: 310, direction: "column", justifyContent: "center", alignItems: "center" }}>
                                                <Typography fontFamily={fontBrand.principal} sx={{ color: gold[500], fontSize: '100%' }}>
                                                    WWW.WORLDGOLFCLUB.COM.AR
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>

            </Card>
        </Container>
    );
}